import { SendFormData } from "../../wcl-helpers";

document.addEventListener('DOMContentLoaded', () => {

   if (document.querySelector('.wcl-modal-confirm-code')) {
      const form = document.querySelector('.wcl-modal-confirm-code');
      const modalFormWrapper = form.closest('.wcl-modal-inner');

      // Get variables
      const wpnonce = form.querySelector('#wcl_confirm_code_wpnonce');
      const resendBtn = form.querySelector('#wcl-js-resend-code');

      // Get UI element
      const messageBlock = form.querySelector('.wcl-message-alert');
      const message = messageBlock.querySelector('.wcl-message');

      resendBtn.addEventListener('click', e => {
         e.preventDefault();

         const userId = form.dataset.userId;
         const userCodeType = form.dataset.codeType;

         messageBlock.classList.remove('show', 'error', 'success');

         modalFormWrapper.classList.add('loading');

         let formData = new FormData(form);

         console.log(formData);

         //return;

         // Add wpnonce to data array
         formData.append('wpnonce', wpnonce.value);
         formData.append('user_id', userId);
         formData.append('code_type', userCodeType);

         SendFormData('resending_code', formData).then(function (res) {
            modalFormWrapper.classList.remove('loading');

            let response = JSON.parse(res);

            if (response.success == '1') {
               messageBlock.classList.add('show', 'success');
               message.innerHTML = response.message;
            } else {
               throw response.message;
            }

         }).catch(function (err) {
            // Error
            modalFormWrapper.classList.remove('loading');

            messageBlock.classList.add('show', 'error');
            message.innerHTML = err;
         });
      });

   }
});